import { useMutation, useQueryClient } from "@tanstack/react-query";
import { googleCalendarApi } from "../api/googleCalendarApi";

export function useDisconnectGoogleCalendarMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: googleCalendarApi.disconnect,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["perfil", "google-calendar-status"] }),
  });
}
